import dataService from '../services/data-service.js';
import dataHelper from '../services/data-helper.js';
import { types } from './mutations';

export default {
  initLocationData( {commit }, payload) {
    if ('locationJSON' in payload) {
      commit(types.INIT_LOCATION_DATA, {...payload});
    }
  },
  initGenderData({ commit }, payload) {
    if ('genderJSON' in payload) {
      commit(types.INIT_GENDER_DATA, {...payload});
    }
  },
  initLanguageData({ commit }, payload) {
    if ('languageJSON' in payload) {
      commit(types.INIT_LANGUAGE_DATA, {...payload});
    }
  },
  initTherapistExperienceData({ commit }, payload) {
    if ('therapistExperienceJSON' in payload) {
      commit(types.INIT_THERAPIST_EXPERIENCE_DATA, {...payload});
    }
  },
  initCulturalExperienceData({ commit }, payload) {
    if ('culturalExperienceJSON' in payload) {
      commit(types.INIT_CULTURAL_EXPERIENCE_DATA, {...payload});
    }
  },
	updateFilterFromButton({ commit, dispatch }, payload) {
		if (payload.ID && payload.FilterName) {
			switch (payload.FilterName) {
				case 'Competency':
          commit(types.ADD_TO_COMPETENCY_FILTER, payload);
          break;
        case 'CulturalExpertise':
          commit(types.ADD_TO_CULTURALEXPERTISE_FILTER, payload);
          break;
        case 'Expertise':
          commit(types.ADD_TO_EXPERTISE_FILTER, payload);
          break;
        case 'Gender':
          commit(types.ADD_TO_GENDER_FILTER, payload);
          break;
        case 'Language':
          commit(types.ADD_TO_LANGUAGE_FILTER, payload);
          break;
      }
      dispatch("applyFiltersToAPICall");			
    }
  },
	updateShowOptions({ commit }, payload) {
    commit(types.UPDATE_SHOW_OPTIONS, payload);
  },
	UpdateShowResultsCountText({ commit }, payload) {
    commit(types.UPDATE_SHOW_RESULTS_COUNT_TEXT, payload);
  },
	UpdateShowNoResultsText({ commit }, payload) {
    commit(types.UPDATE_SHOW_NO_RESULTS_TEXT, payload);
  },
	removeFilterFromButton({ commit, dispatch }, payload) {
		if (payload.ID && payload.FilterName) {
      switch (payload.FilterName) {
				case 'Competency':
          commit(types.REMOVE_FROM_COMPETENCY_FILTER, payload);
          break;
        case 'CulturalExpertise':
          commit(types.REMOVE_FROM_CULTURALEXPERTISE_FILTER, payload);
          break;
        case 'Expertise':
          commit(types.REMOVE_FROM_EXPERTISE_FILTER, payload);
          break;
        case 'Gender':
          commit(types.REMOVE_FROM_GENDER_FILTER, payload);
          break;
        case 'Language':
          commit(types.REMOVE_FROM_LANGUAGE_FILTER, payload);
          break;
      }
      dispatch("applyFiltersToAPICall");
    }
  },
  updateRegion ({ commit, dispatch }, payload) {
    commit(types.CHANGE_REGION, payload);
    dispatch('updateAvailableSubRegions', payload);
    dispatch("applyFiltersToAPICall");
  },
  updateAvailableSubRegions({ commit }, payload) {
    commit(types.CHANGE_AVAILABLE_SUBREGIONS, payload);
  },
  updateSubRegions({ commit, dispatch }, payload) { 
    commit(types.ADD_SUBREGIONS, payload);
    dispatch("applyFiltersToAPICall");
  },
  deleteSubRegions({ commit, dispatch }, payload) {
    commit(types.DELETE_SUBREGIONS, payload);
    dispatch("applyFiltersToAPICall");
  },
	clearAllFilters({ commit, dispatch }) {
    commit(types.CLEAR_ALL_FILTERS);
    dispatch("applyFiltersToAPICall");
  },
  applyFiltersToAPICall({ commit }) {
    commit(types.QUERY_STRING_PARAMS_TO_API);
  },
  APICallWithQsParams({ commit, dispatch }, payload) {
    //Check if valid querystring before running any mutations
    const qsObj = Object.fromEntries(new URLSearchParams(payload));
    const errorObj = { "error": document.getElementById('api-error-text').innerText };
    let validQuerystring = false;
    let queryStringErrors = 0;

    Object.keys(qsObj).forEach(function (key) {
      if (dataHelper.isValidQsKey(key)) {
        if (key == 'Page') {
          if (dataHelper.isValidNumber(qsObj[key])) {
            validQuerystring = true;
          } else {
            commit(types.API_ERROR, errorObj);
            queryStringErrors++;
          }
        }
        else if (key == 'ContractRegion') {
          if (dataHelper.isValidNumber(qsObj[key])) {
            validQuerystring = true;
          } else {
            commit(types.API_ERROR, errorObj);
            queryStringErrors++;
          }
        } else if (key == 'ContractSubRegion') {
          if (dataHelper.isValidQuerystring(qsObj[key])) {
            validQuerystring = true;
          } else {
            commit(types.API_ERROR, errorObj);
            queryStringErrors++;
          }
        } else if (key == 'Gender') {
          if (dataHelper.isValidQuerystring(qsObj[key])) {
            validQuerystring = true;        
          } else {
            commit(types.API_ERROR, errorObj);
            queryStringErrors++;
          }
        } else if (key == 'Language') {
          if (dataHelper.isValidQuerystring(qsObj[key])) {
            validQuerystring = true;                
          } else {
            commit(types.API_ERROR, errorObj);
            queryStringErrors++;
          }
        } else if (key == 'Competency') {
          if (dataHelper.isValidQuerystring(qsObj[key])) {
            validQuerystring = true;         
          } else {
            commit(types.API_ERROR, errorObj);
            queryStringErrors++;
          }
        } else if (key == 'Expertise') {
          if (dataHelper.isValidQuerystring(qsObj[key])) {
            validQuerystring = true; 
          }       
        } 
      } else {
        commit(types.API_ERROR, errorObj);
        queryStringErrors++;
      } 
    });

    if (validQuerystring && queryStringErrors == 0) {
      commit(types.URL_QUERY_STRING_PARAMS_TO_API, payload);
      const RegionID = dataHelper.getValueById(payload, "ContractRegion");
      const regObj = {'regionID': RegionID};
      dispatch('updateAvailableSubRegions', regObj);
      dispatch("applyFiltersToAPICall");
      dispatch("APICall", payload);
    }
  },
  async APICall({ commit, dispatch }, payload) {
    const { ok, data, error } = await dataService.getProviders(payload);
    if (ok) {
      commit(types.FILTER_SEARCH_RESULT, data);
      dispatch("applyPagination", data);

      //Region dropdowns not available until here if populating search results from querystring. 
      const RegionID = dataHelper.getValueById(payload, "ContractRegion");
      if (RegionID) {
        document.getElementById("Regions").selectedIndex = Number.parseInt(RegionID);
      }
    } else {
      commit(types.API_ERROR, { error });
    }
  },
  applyPagination({ commit }, payload) {
    commit(types.BUILD_PAGINATION_ARRAY, payload);
  }
}